import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {
    chart: {
        type: 'pie'
    },
    title: {
        text: 'Uso de receitas'
    },
    xAxis: {
        categories: ['Geral']
    },
    yAxis: {
        min: 0,
        title: {
            text: '%'
        },
        stackLabels: {
            enabled: true,
            style: {
                fontWeight: 'bold',
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
        }
    },
    legend: {
        align: 'right',
        x: -30,
        verticalAlign: 'top',
        y: 25,
        floating: true,
        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false
    },
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            dataLabels: {
                enabled: true,
                color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
        }
    },
    series: []
};

export default function RaspaRecipeRecipeUsageChart(prop) {
    const { series } = prop;

    if (series) {
        let categories = [];
        let dataMaq = [];
        let dataOper = [];

        series.map(i => {
            //categories.push(i.data.substring(0, 10));
            dataMaq.push( { name: 'Com receita',
                            y: Math.round( i.WithRecipe),
                            sliced: true
                        });
            dataMaq.push( { name: 'Sem receita',
                            y: Math.round( i.WithoutRecipe),
                            sliced: true
                        });
        })

        config = {
            ...config,

            series: [
                {
                    name: 'Uso de receitas',
                    data: dataMaq
                }

            ],
        }

    }


    return (
        <Card>
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
